import styled from 'styled-components'
import { TOPBAR_MOBILE_HEIGHT } from '@/v2/constants'

export const Container = styled.div`
  position: fixed;
  top: ${TOPBAR_MOBILE_HEIGHT};
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  display: flex;
  flex-direction: column;
  background: #fff;
  z-index: 101;
  box-sizing: border-box;
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
  margin: 0;
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background: #fff;
  border-bottom: 1px solid #eee;
  flex-shrink: 0;

  @media (min-width: 768px) {
    padding: 16px 32px;
  }
`

export const Content = styled.div`
  flex: 1;
  padding: 16px;
  padding-bottom: 100px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  @media (min-width: 768px) {
    flex-direction: row;
    gap: 48px;
    padding: 32px;
    padding-bottom: 100px;
  }
`

export const PatientSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (min-width: 768px) {
    flex: 1;
  }
`

export const AppointmentSection = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: 768px) {
    flex: 1;
  }
`
